import { memo } from "react";

import { GuestPageVisibilityMode } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { Label } from "@/components/ui/label/label";

const GUIDE =
	"「検索に表示しない」をオンにして保存すると、Google などの検索結果にページが表示されなくなります。URL を知っている方は、これまでどおりページを開いてご予約いただけます。すでに検索結果に表示されているページが表示されなくなる時期は、Google などの検索エンジンによって異なります（数日〜数週間かかる場合があります）。";

type Props = {
	visibility: GuestPageVisibilityMode | undefined;
	/** チェックを切り替えたとき（チェックありは検索に表示しない） */
	onChangeUnlisted: (isUnlisted: boolean) => void;
};

/**
 * ゲストページを「検索に表示しない」にするかどうかの設定項目
 *
 * チェックありは検索に表示しない（UNLISTED）、なしはそれ以外（未設定・公開）。
 * 「検索に表示」をチェックで見せると、必ず検索結果に出ると誤解されやすいため、「検索に表示しない」だけを選べる形にする。
 * 非公開（PRIVATE）は管理者だけが設定し施設は変えられないので、チェックボックスを出さずに案内だけにする。
 * 保存は置いた画面の保存ボタンで行う。
 */
export const GuestPageVisibilityQuestion = memo(({ visibility, onChangeUnlisted }: Props) => {
	if (!visibility) return null;

	return (
		<QuestionForMain
			title="検索エンジンへの表示設定"
			guide={GUIDE}
			inputChildren={
				visibility === GuestPageVisibilityMode.Private ? (
					<div className="flex items-center gap-x-2">
						<Label variant="pink" text="非公開" size="sm" />
						<p className="text-sm text-zinc-500">
							このページは非公開に設定されています。公開については CHILLNN
							サポートまでお問い合わせください。
						</p>
					</div>
				) : (
					<CheckboxField
						value={visibility === GuestPageVisibilityMode.Unlisted}
						label="検索に表示しない"
						handleChange={onChangeUnlisted}
					/>
				)
			}
		/>
	);
});

GuestPageVisibilityQuestion.displayName = "GuestPageVisibilityQuestion";
